import { spacing } from 'ui/theme';

/**
 * The size of the gap between child elements.
 * To add a new size, add a new key-value pair to this object.
 */
export const SPACING_SIZE = {
  noGap: '0',
  actionGap: spacing.half,
  cardGap: spacing.plusHalf,
  floatGap: spacing.quarter,
  quarter: spacing.quarter,
  threeQuarter: spacing.threeQuarter,
  half: spacing.half,
  base: spacing.base,
  plusHalf: spacing.plusHalf,
  double: spacing.double,
} as const;

export const PADDING_SIZE = {
  noPadding: '0',
  cardPadding: spacing.plusHalf,
  pageHeaderPadding: spacing.double,
} as const;
